<template>
  <div>
    <Grid
      ref="grid"
      :columns="gridColumns"
      resource="contracts"
      :showActions="false"
    />
  </div>
</template>
<script>
import { uniq, pick } from 'lodash';
import Grid from '@/components/grid';

export default {
  name: 'ContractsList',
  components: { Grid },
  data() {
    return {
      contracts: [],
      gridColumns: [
        { description: 'Contrato', field: 'contract_id' },
        { description: 'Plano', field: 'plan_description' },
        { description: 'Titular', field: 'owner_name' }
      ]
    };
  },

  methods: {
    setContracts(payments) {
      const ids = uniq(payments.map(p => p.contract_id));
      const contracts = [];
      ids.forEach(id => {
        let contract = payments.find(p => p.contract_id == id);
        contract = pick(contract, [
          'contract_id',
          'owner_name',
          'plan_description'
        ]);
        contracts.push(contract);
      });

      this.contracts = contracts;
      this.$refs.grid.setItems(contracts);
    }
  }
};
</script>
